<template>
	<div class="dataReport">
		<!-- 数据报表 -->
		<div class="dataScreening">
			<div style="display: flex; justify-content: space-between">
				<span>{{$t('DataRecycling.DataScreening')}}</span>
				<!-- <span>{{$t('DataRecycling.UpdatedOn')}} : {{ screening.updateTime }}</span> -->
			</div>

			<div class="data_box">
				<div class="data_show">
					<span>{{$t('DataRecycling.NewDataAddedToday')}}</span>
					<span style="margin-top: 35px; font-size: 28px; color: #ff4200">{{ screening.todayNewDate }}</span>
				</div>
				<div class="data_show">
					<span>{{$t('DataRecycling.TotalDataVolume')}}</span>
					<span style="margin-top: 35px; font-size: 28px; color: #0080ff">{{ screening.allData }}</span>
				</div>
				<div class="data_show_right">
					<span>{{$t('DataRecycling.AverageAnswerTime')}}</span>
					<span style="margin-top: 35px; font-size: 28px; color: #33a83b">{{ screening.averageAnswerTime }}</span>
				</div>
			</div>
		</div>
		
		<filtrate @loadfiltrate="loadfiltrate"></filtrate>
		
		<div class="data_table_box">
			<span>{{$t('DataRecycling.DataDetails')}}</span>
			<div class="data_table">
				<div class="flex flex-end" style="border-bottom: 1px solid #eee; padding-bottom: 15px">
					<div
						@click="openSettings"
						type="text"
						style=" text-align:center;height: 40px;line-height: 40px ;margin-top: 10px; margin-right: 10px;cursor: pointer;"
					>
						<i class="el-icon-s-tools"></i>
						{{$t('DataRecycling.SetUp')}}
					</div>
					<el-button type="primary" plain style=" width:120px ;margin-top: 10px; margin-right: 10px" @click="centerDialogVisible = true">{{$t('DataRecycling.Export')}}</el-button>

					<el-dropdown @command="dropdownClick">
						<el-button plain style="margin-top: 10px; margin-right: 10px" type="primary">
							{{$t('DataRecycling.ExportAttachments')}}
							<i class="el-icon-arrow-down el-icon--right"></i>
						</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="1">{{$t('DataRecycling.ExportPicture')}}</el-dropdown-item>
							<el-dropdown-item command="2">{{$t('DataRecycling.ExportRecording')}}</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<!-- <el-dropdown>
						<el-button plain style="margin-top: 10px; margin-right: 10px">
							批量操作
							<i class="el-icon-arrow-down el-icon--right"></i>
						</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item>选中答卷标记无效</el-dropdown-item>
							<el-dropdown-item>下载选中答卷</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>

					<el-button plain style="margin-top: 10px; margin-right: 10px" @click="centerDialogVisible = true">分享</el-button>

					<el-dropdown>
						<el-button plain style="margin-top: 10px; margin-right: 10px">
							更多
							<i class="el-icon-arrow-down el-icon--right"></i>
						</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item>全屏</el-dropdown-item>
							<el-dropdown-item>添加单份数据</el-dropdown-item>
							<el-dropdown-item>批量导入数据</el-dropdown-item>
							<el-dropdown-item>查看无效答卷</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown> -->
				</div>

				<el-dialog :title="$t('DataRecycling.ExportData')" :visible.sync="centerDialogVisible" width="40%" :close-on-click-modal="false">
					<div style="margin-left: 30px; margin-top: 20px">
						<!-- <div class="flex align-items">
							<span style="margin-right: 20px">导出类型</span>
							<el-radio-group v-model="radio" @change="aa">
								<el-radio :label="1" value="1">原始数据</el-radio>
								<el-radio :label="2" value="2">数据报表</el-radio>
							</el-radio-group>
						</div>
						<div class="flex align-items" style="margin-top: 20px">
							<span style="margin-right: 20px">导出格式</span>
							<el-radio-group v-model="radiodc" v-if="radio == 1" @change="csv">
								<el-radio :label="1" value="1">导出CSV</el-radio>
							</el-radio-group>
							<el-radio-group v-model="radiodc" v-if="radio == 2" @change="cel">
								<el-radio :label="1" value="1">导出Excel</el-radio>
								<el-radio :label="2" value="2">导出Word</el-radio>
							</el-radio-group>
						</div> -->

						<div class="flex align-items" style="margin-top: 20px">
							<span style="margin-right: 20px">{{$t('DataRecycling.ExportContent')}}</span>
							<el-radio-group v-model="contextType" @change="aa">
								<el-radio :label="1" value="1">{{$t('DataRecycling.DataDetailsTable')}}</el-radio>
								<!-- <el-radio :label="2" value="2">答卷集合</el-radio> -->
							</el-radio-group>
						</div>
						<div class="flex align-items" style="margin-top: 20px">
							<span style="margin-right: 20px">{{$t('DataRecycling.DataType')}}</span>
							<el-radio-group v-model="dateType" @change="aa">
								<el-radio :label="1" value="1">{{$t('DataRecycling.RawData')}}</el-radio>
								<el-radio :label="2" value="2">{{$t('DataRecycling.CodedData')}}</el-radio>
							</el-radio-group>
						</div>
						<div class="flex align-items" style="margin-top: 20px">
							<span style="margin-right: 20px">{{$t('DataRecycling.ExhibitionFormat')}}</span>
							<el-radio-group v-model="showType" @change="aa">
								<el-radio :label="1" value="1">{{$t('DataRecycling.OneQuestionOneColumn')}}</el-radio>
								<el-radio :label="2" value="2">{{$t('DataRecycling.OneQuestionWithMultipleColumns')}}</el-radio>
							</el-radio-group>
						</div>
						<div class="flex align-items" style="margin-top: 20px">
							<span style="margin-right: 20px">{{$t('DataRecycling.ExportFormat')}}</span>
							<el-checkbox-group v-model="exportTypes">
								<el-checkbox label="1">Excel(.xlsx)</el-checkbox>
								<el-checkbox label="2">CSV(.csv)</el-checkbox>
								<el-checkbox label="4" v-if="dateType == 2">SPSS(.sav)</el-checkbox>
							</el-checkbox-group>
						</div>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button size="medium" @click="centerDialogVisible = false">{{$t('main.cancel2')}}</el-button>
						<el-button size="medium" type="primary" @click="exportExcl">{{$t('DataRecycling.Export')}}</el-button>
					</span>
				</el-dialog>

				<div style="width: 100%; height: auto; background: #fff; margin-top: 16px">
					<div class="data_table_xqly">
						<el-table
							class="tb-edit"
							highlight-current-row
							:data="tableData"
							border
							tooltip-effect="dark"
							ref="multipleTable"
							style="width: 100%"
							@selection-change="handleSelectionChange"
						>
							<el-table-column align="center" fixed type="selection" width="55"></el-table-column>

							<el-table-column
								v-for="(col, index) in tableLabel"
								align="center"
								show-overflow-tooltip
								:prop="col.enfieldName"
								:label="col.chfieldName"
								:fixed="col.fixed"
								:key="index"
								min-width="140"
							></el-table-column>

							<el-table-column align="center" fixed="right" :label="$t('DataRecycling.Operate')">
								<template slot-scope="scope">
									<el-button size="mini" @click="handleEdit(scope.$index, scope.row)">{{$t('DataRecycling.Details')}}</el-button>
								</template>
							</el-table-column>
						</el-table>
						<!-- 分页 -->
						<el-pagination 
							class="PageSet" 
							@current-change="handleCurrentChange" 
							background 
							layout="prev, pager, next" 
							:page-size="pagination.pageSize"
							:current-page="pagination.currentPage"
							:total="pagination.total"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>

		<exportImg ref="exportImg"></exportImg>
		<exportRecording ref="exportRecording"></exportRecording>
		<dataReportSetPage ref="dataReportSetPage" @setShowFieldOk="setShowFieldOk"></dataReportSetPage>
		
		<el-dialog :title="$t('DataRecycling.ModificationPrompt')" :visible.sync="dialogVisible" width="30%" :before-close="handleClose" :close-on-click-modal="false">
			<div style="padding: 15px; text-indent: 2em"><span>{{$t('DataRecycling.ModifyQuestionnaireTip')}}</span></div>
		
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="dialogVisible = false">{{$t('main.cancel2')}}</el-button>
				<el-button size="medium" type="primary" @click="handleConfirmClick">{{$t('main.ok2')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import exportImg from './exportData/exportImg.vue';
import exportRecording from './exportData/exportRecording.vue';
import dataReportSetPage from './dataReportSetPage/index.vue';
import filtrate from '@/page/filtrate';
export default {
	components: {
		exportImg,
		exportRecording,
		dataReportSetPage,
		filtrate
	},
	data() {
		return {
			next: null,
			dialogVisible:false,
			contextType: 1,
			dateType: 1,
			showType: 1,
			exportTypes: ['1'],
			radiodc: 1,
			radio: 1,
			centerDialogVisible: false,
			// wid:0,
			screening: {},
			tableData: [
				{
					source: '2',
					submitDate: '3',
					answerTime: '4'
				}
			],
			tableLabel: [
				{
					chfieldName: this.$t('DataRecycling.FullName'),
					enfieldName: 'username',
					fixed: 'left'
				},
				{
					chfieldName: this.$t('DataRecycling.Age'),
					enfieldName: 'age',
					fixed: 'left'
				},
				{
					chfieldName: this.$t('DataRecycling.SampleStatusName'),
					enfieldName: 'answerName',
					fixed: 'left'
				}
			],
			multipleTable: [],
			options: [],
			value: '',
			pagination: {
				currentPage: 1,
				pageSize: 10,
				total: 0
			},
			filtrateScreening: ''
		};
	},
	created() {
		this.wid = sessionStorage.getItem('wid');
		this.queryQuestion(); //设置表头
		// this.queryTotaldata();
		// this.queryData(); //获取数据
	},
	mounted() {
		this.wid = sessionStorage.getItem('wid');
		this.queryQuestion(); //设置表头
		// this.queryTotaldata();
		// this.queryData(); //获取数据
	},
	beforeRouteLeave(to, from, next) {
		// 导航离开该组件的对应路由时调用
		// 可以访问组件实例 `this`
		if (to.name != 'QuestionType') {
			next();
		} else {
			let state = sessionStorage.getItem('wstate');
			if (state && state != 1) {
				this.next = next;
				this.dialogVisible = true;
			} else {
				next();
			}
		}
	},
	methods: {
		handleClose() {
			this.dialogVisible = false;
		},
		handleConfirmClick() {
			this.dialogVisible = false;
			this.wid = sessionStorage.getItem('wid') || 0;
			this.$api.UpdateQuestionnaireState({
				id: this.wid,
				state: 1
			});
			this.next();
		},
		loadfiltrate(val) {
			console.log(val);
			this.filtrateScreening = val;
			this.queryQuestion(); //设置表头
		},
		setShowFieldOk() {
			this.queryQuestion(); //
			// this.queryData();
		},
		openSettings() {
			this.$refs.dataReportSetPage.openSettings();
		},
		dropdownClick(command) {
			if (command == 1) {
				this.$refs.exportImg.openExportimg();
			} else if (command == 2) {
				this.$refs.exportRecording.openExportRecording();
			}
		},
		exportExcl() {
			var id = this.wid;
			let that = this;
			
			let tempScreening = {
				id: id,
				contextType: that.contextType,
				dateType: that.dateType,
				exportTypes: that.exportTypes,
				showType: that.showType
			};
			if (that.filtrateScreening != '') {
				tempScreening = JSON.parse(that.filtrateScreening) ;
				tempScreening.id = id;
				tempScreening.contextType = that.contextType;
				tempScreening.dateType = that.dateType;
				tempScreening.exportTypes = that.exportTypes;
				tempScreening.showType = that.showType;
			}
			
			let params = {
				that: this,
				url: `${this.$config.service.objgradeCountExport}`,
				method: 'POST',
				data: tempScreening,
				cb(res) {
					if (res.code == 0) {
						that.centerDialogVisible = false;
						that.popUpPrompt()
					}
				}
			};
			this.$util.request(params);
		},
		popUpPrompt() {
			this.$notify({
				dangerouslyUseHTMLString: true,
				message: `${this.$t('DataRecycling.DataPreparationInProgress')} 
							<a href="#" class="notify-link" id="my-download-link">
								<span style="color: blue;">${this.$t('DataRecycling.MyDownload')}</span>
							</a> 
							${this.$t('DataRecycling.CanViewProgress')}`
			});
			this.$nextTick(() => {
				const link = document.querySelector('#my-download-link');
				if (link) {
					link.addEventListener('click', (e) => {
						e.preventDefault(); // 阻止默认的链接跳转
						this.$router.push('/MyProject'); // 使用 Vue Router 跳转
					});
				}
			});
		},
		aa() {},
		csv() {},
		cel() {},
		// 分页
		handleCurrentChange(val) {
			this.pagination.currentPage = val
			this.queryData();
		},
		handleEdit(index, row) {
			// this.$router.replace({
			// 	path: '/Details',
			// 	query: {
			// 		wid:this.wid,
			// 		id: row.id,
			// 		type: 3
			// 	}
			// });

			let routeData = this.$router.resolve({ path: '/Details', query: { wid: this.wid, id: row.id, type: 3 } });
			window.open(routeData.href, '_blank'); //跳转新页面
		},
		expo() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.exportQuestionsData}`,
				method: 'POST',
				data: {
					pageQuery: {
						pageIndex: 1,
						pageSize: 10
					},
					questionnaireId: that.wid,
					state: 0
				},
				cb(res) {
					if (res.code == 0) {
						window.open();
					}
				}
			};
			this.$util.request(params);
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		queryTotaldata() {
			let that = this;
			let id = that.wid;
			let params = {
				that: this,
				// ${that.$config.service.questiondel}?id=${id}
				url: `${this.$config.service.querydataSurvey}?questionnaireId=${id}`,
				method: 'GET',
				data: {},
				cb(res) {
					if (res.code == 0) {
						that.screening = res.resultBody;
					}
				}
			};
			this.$util.request(params);
		},
		queryQuestion() {
			// 旧
			// let that = this;
			// let params = {
			// 	that: this,
			// 	url: `${this.$config.service.queryQuestions}`,
			// 	method: 'POST',
			// 	data: {
			// 		id: that.wid
			// 	},
			// 	cb(res) {
			// 		if (res.code == 0) {
			// 			that.tableLabel = res.resultBody.questionsList;
			// 		}
			// 	}
			// };
			// this.$util.request(params);

			//新
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.fieldConfDetails}?id=${this.wid}`,
				method: 'GET',
				data: {},
				cb(res) {
					console.log(res);
					if (res.code == 0) {
						let tableLabel = [];
						// 访员
						let interviewerFieldLeft = res.resultBody.interviewerFieldLeft.split(',');
						let interviewerFieldShow = res.resultBody.interviewerFieldShow.split(',');
						let interviewerFieldNameShow = res.resultBody.interviewerFieldNameShow.split(',');
						interviewerFieldShow.forEach((item, index) => {
							if (item != '') {
								let obj = {
									chfieldName: interviewerFieldNameShow[index],
									enfieldName: item
								};
								tableLabel.push(obj);
							}
						});
						// 问卷
						let questionnaireFieldLeft = res.resultBody.questionnaireFieldLeft.split(',');
						let questionnaireFieldShow = res.resultBody.questionnaireFieldShow.split(',');
						let questionnaireFieldNameShow = res.resultBody.questionnaireFieldNameShow.split(',');

						questionnaireFieldShow.forEach((item, index) => {
							if (item != '') {
								let obj = {
									chfieldName: questionnaireFieldNameShow[index],
									enfieldName: item
								};
								tableLabel.push(obj);
							}
						});
						// 样本
						let sampleFieldLeft = res.resultBody.sampleFieldLeft.split(',');
						let sampleFieldShow = res.resultBody.sampleFieldShow.split(',');
						let sampleFieldNameShow = res.resultBody.sampleFieldNameShow.split(',');

						sampleFieldShow.forEach((item, index) => {
							if (item != '') {
								let obj = {
									chfieldName: sampleFieldNameShow[index],
									enfieldName: item
								};
								tableLabel.push(obj);
							}
						});
						tableLabel.forEach(item => {
							interviewerFieldLeft.forEach(leftItem => {
								if (item.enfieldName == leftItem) {
									item.fixed = 'left';
								}
							});
							questionnaireFieldLeft.forEach(leftItem => {
								if (item.enfieldName == leftItem) {
									item.fixed = 'left';
								}
							});
							sampleFieldLeft.forEach(leftItem => {
								if (item.enfieldName == leftItem) {
									item.fixed = 'left';
								}
							});
							item.chfieldName = that.htmlToString(item.chfieldName);
						});
						console.log('tableLabel', tableLabel);
						that.tableLabel = tableLabel;
						that.queryTotaldata();
						that.queryData(); //获取数据
					} else {
						that.$message.error(res.message);
						that.queryTotaldata();
						that.queryData(); //获取数据
					}
				}
			};
			this.$util.request(params);
		},
		htmlToString(htmlStr) {
			return htmlStr.replace(/<\/?.+?\/?>|\r|\n*/g, '');
		},
		queryData() {
			let that = this;
			// that.tableData.length = 0;
			
			let tempScreening = {
				state: 0,
				questionnaireId: that.wid,
				pageQuery: {
					pageIndex: this.pagination.currentPage,
					pageSize: this.pagination.pageSize
				},
			};
			if (that.filtrateScreening != '') {
				tempScreening = JSON.parse(that.filtrateScreening);
				tempScreening.state = 0;
				tempScreening.questionnaireId = that.wid;
				tempScreening.pageQuery = {
					pageIndex: this.pagination.currentPage,
					pageSize: this.pagination.pageSize
				};
			}
			
			let params = {
				that: this,
				url: `${this.$config.service.queryQuestionsData}`,
				method: 'POST',
				data: tempScreening,
				cb(res) {
					if (res.code == 0) {
						let newTableData = [];
						let tableData = res.resultBody.datas;
						console.log(tableData);
						console.log(that.tableLabel);
						tableData.forEach(item1 => {
							let obj = {};
							item1.sampleFields.forEach(item2 => {
								that.tableLabel.forEach(item3 => {
									if (item2.enfieldName == item3.enfieldName) {
										obj.id = item1.id;
										obj[item3.enfieldName] = that.$functions.htmlFormat(item2.chfieldName.replace(/<br\/>/g, '； '));
									}
								});
							});
							newTableData.push(obj);
						});
						newTableData.forEach(item => {
							if (item.beginTime) {
								// console.log('111111111111', item.beginTime);
								item.beginTime = that.dateFormat(item.beginTime);
							}
							if (item.endTime) {
								item.endTime = that.dateFormat(item.endTime);
							}
						});
						that.tableData = newTableData;
						console.log('表格数据', that.tableData);
						that.pagination.total = res.resultBody.total;
					} else {
						// that.$message.error(res.message);
						that.tableData = [];
						that.pagination.total = 0;
					}
				}
			};
			this.$util.request(params);
		},
		//格式化处理
		dateFormat(time) {
			let date = new Date(time);
			let year = date.getFullYear();
			// 在日期格式中，月份是从0开始的，因此要加0，使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
			let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
			let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
			let hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
			let minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
			let seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
			// 拼接
			return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
			// return year + "-" + month + "-" + day;
		}
	}
};
</script>

<style lang="scss" scoped>
.data_table_select {
	width: 1715px;
	height: auto;
	margin: 0 auto;
	padding-top: 20px;
	display: flex;
	justify-content: space-between;
}

.data_table_box {
	height: auto;
}

.data_table {
	height: auto;
	margin-top: 16px;
	background: #fff;
}

.data_table_xqly {
	margin: 0 auto;
	padding-top: 20px;
	padding-bottom: 76px;
	padding: 20px 10px 76px 10px;
}

.data_show_right {
	width: 563px;
	height: 80px;
	text-align: center;
	font-size: 14px;
	display: flex;
	flex-direction: column;
}

.data_show {
	width: 563px;
	height: 80px;
	border-right: 1px dashed #ccc;
	text-align: center;
	font-size: 14px;
	display: flex;
	flex-direction: column;
}

.dataReport {
	height: auto;
}

.data_box {
	height: 120px;
	background: #ffffff;
	box-shadow: 0px 2px 5px 0px rgba(176, 176, 176, 0.7);
	margin-top: 16px;
	display: flex;
	align-items: center;
}

.dataScreening {
	height: auto;
	margin-top: 26px;
}

.PageSet {
	margin-top: 10px;
	float: right;
}
</style>
